import React, { useState } from "react"
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share"
import PropTypes from "prop-types"
import { track } from "./analytics"

const style = {
  margin: "0 8px",
  cursor: "pointer",
  outline: "none",
}

const shares = [
  {
    component: FacebookShareButton,
    child: FacebookIcon,
    name: "facebook",
  },
  {
    component: TwitterShareButton,
    child: TwitterIcon,
    name: "twitter",
  },
  {
    component: LinkedinShareButton,
    child: LinkedinIcon,
    name: "linkedin",
  },
]

const SocialShares = ({
  url,
  subcomponentClassName,
  className = "flex justify-center bg-primary py-4",
  buttonClassName = "",
  logoColor = "black",
  iconBgColor = "white",
  hoverColor = "rgb(38, 227, 186)",
  quote = "Get up to $50 in free crypto with another chance at credit - without paying anything.",
}) => {
  const [hover, setHover] = useState(null)

  return (
    <div className={className}>
      {shares.map((s, index) => {
        const SocialComponent = s.component
        const ChildComponent = s.child
        return (
          <SocialComponent
            key={s.name}
            className={`socialButton ${subcomponentClassName || ""}`}
            url={url}
            quote={quote}
            style={style}
            beforeOnClick={() => {
              track("LANDING_SOCIAL_SHARE_CLICKED", {
                social: s.name,
              })
            }}
          >
            <div
              onMouseEnter={() => {
                setHover(index)
              }}
              onMouseLeave={() => {
                setHover(null)
              }}
            >
              <ChildComponent
                className={`socialButton ${buttonClassName}`}
                iconBgStyle={{
                  fill: hover === index ? hoverColor : iconBgColor,
                }}
                size={32}
                borderRadius={2}
                logoFillColor={logoColor}
              />
            </div>
          </SocialComponent>
        )
      })}
    </div>
  )
}

SocialShares.propTypes = {
  title: PropTypes.string,
  buttonClassName: PropTypes.string,
}

export default SocialShares
